import { useLanguage } from "../../../i18n/LanguageContext";
import "./presence.css";

const text = {
    en: {
        room: "Room 214",
        live: "Live",
        occupied: "Occupied",
        awake: "Guest is awake",
        resting: "Guest is resting",
        vacant: "Vacant",
        ready: "Ready for housekeeping",
        motion: "Motion",
        heat: "Body heat",
        alert: "Staff are alerted if there is no movement for 12 hours",
    },
    ar: {
        room: "الغرفة 214",
        live: "مباشر",
        occupied: "مشغولة",
        awake: "الضيف مستيقظ",
        resting: "الضيف يستريح",
        vacant: "شاغرة",
        ready: "جاهزة للتنظيف",
        motion: "الحركة",
        heat: "حرارة الجسم",
        alert: "يُنبَّه الفريق إذا لم تُرصد أي حركة لمدة 12 ساعة",
    },
};

// Ceiling sensor reads the room: guest awake -> guest resting -> room vacant. One 12s loop.
const PresenceScene = () => {
    const { lang, isRtl } = useLanguage();
    const t = text[lang];
    return (
        <>
            <div className="skp-room">
                <div className="skp-window"><i></i></div>
                <div className="skp-floor"></div>
                <div className="skp-lamp"></div>

                <div className="skp-cone"></div>
                <div className="skp-ping"></div>
                <div className="skp-ping p2"></div>
                <div className="skp-sensor"><i></i></div>

                <div className="skp-bed">
                    <div className="skp-headboard"></div>
                    <div className="skp-mattress"></div>
                    <div className="skp-pillow"></div>
                    <div className="skp-blanket"></div>
                </div>

                <div className="skp-walker">
                    <div className="skp-heat"></div>
                    <svg viewBox="0 0 40 100">
                        <circle cx="20" cy="12" r="9" />
                        <rect x="9" y="24" width="22" height="40" rx="10" />
                        <rect x="11" y="58" width="7" height="38" rx="3.5" />
                        <rect x="22" y="58" width="7" height="38" rx="3.5" />
                    </svg>
                </div>

                <div className="skp-sleeper">
                    <div className="skp-heat skp-heat-wide"></div>
                    <div className="skp-sleeper-body"></div>
                    <div className="skp-sleeper-head"></div>
                    <span className="skp-z">z</span>
                    <span className="skp-z z2">z</span>
                    <span className="skp-z z3">z</span>
                </div>

                <div className="skp-night"></div>
            </div>

            <div className="sk-panel skp-panel" dir={isRtl ? "rtl" : "ltr"}>
                <div className="sk-panel-title">{t.room} <b>{t.live}</b></div>

                <div className="skp-states">
                    <div className="skp-state s1">
                        <span className="skp-badge"></span>
                        <span><b>{t.occupied}</b>{t.awake}</span>
                    </div>
                    <div className="skp-state s2">
                        <span className="skp-badge"></span>
                        <span><b>{t.occupied}</b>{t.resting}</span>
                    </div>
                    <div className="skp-state s3">
                        <span className="skp-badge"></span>
                        <span><b>{t.vacant}</b>{t.ready}</span>
                    </div>
                </div>

                <div className="skp-meter">
                    <span>{t.motion}</span>
                    <div className="skp-bar"><i className="skp-motion"></i></div>
                </div>
                <div className="skp-meter">
                    <span>{t.heat}</span>
                    <div className="skp-bar"><i className="skp-heatbar"></i></div>
                </div>

                <div className="skp-alert">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10.3 21a1.9 1.9 0 0 0 3.4 0" />
                    </svg>
                    {t.alert}
                </div>
            </div>
        </>
    )
}
export default PresenceScene;
